// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2SE8s","footerInner":"style_footerInner__1oSKJ","logo":"style_logo__hQZd2"};